import React from 'react';
import { Div, Label, Img } from './styles';
var Title = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, className = _a.className, title = _a.title, openImg = _a.openImg, closeImg = _a.closeImg, isOpen = _a.isOpen;
    return (React.createElement(Div, { className: className },
        React.createElement(Label, null, title),
        React.createElement(Img, { onClick: onClick, src: isOpen ? closeImg : openImg })));
};
export default Title;
